import { CHANGE_CONSENT } from '../actions/types';

const defaultState = {
  targeting: null,
  performance: null,
  functional: null,
  social: null,
};

export const applicationSaveUserConsentReducer = (previousState = defaultState, action) => {
  let consentSettings = previousState;
  if (action.type === CHANGE_CONSENT) {
    consentSettings = action.payload;
  }
  return consentSettings;
};
